import React, { useEffect, useState } from 'react'
import {useFormik} from "formik";
import * as Yup from "yup";
import useLogin from '../../login/hooks/login.hook';
import Input from '../../../../components/input';
import Checkbox from '../../../../components/checkbox';
import EyeIcon from "../../../../components/svg/EyeIcon";
import {Link, NavLink} from 'react-router-dom';
import PhoneInput from 'react-phone-number-input'
import Button from '../../../../components/button';
import Flex from '../../../../components/flex';
import Section from '../../../../components/section';
import Text from '../../../../components/text';
import AccessCardDigitsImg from '../../../../assets/images/millennium-access-card-digits.jpg';
import Image from '../../../../components/image';

const RegisterView = props => {
    const {onSubmitRegister, garagesList} = props
    const [phoneNumber, setPhoneNumber] = useState('');


    const handleRecaptchaVerify = (values, actions) => {
        window.grecaptcha.ready(_ => {
            window.grecaptcha
                .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" })
                .then(token => {
                    onSubmitRegister(values, actions)
                })
        })
    }

    const handleCheckBoxChange = (e) => {
        const values = formik.values.garage;
        //console.log('values 1', values)
        if(e.target.checked){
            console.log('if', e.target.checked, values)
            values.push(e.target.value)
        } else {
            console.log('if else', e.target.checked, values)
            values.splice(e.target.value);
        }
        //console.log('values 2', values)
        formik.setFieldValue('garage', values);
    };

    const {
        showPassword,
        showPasswordClick,
        showConfirmPassword,
        showConfirmPasswordClick,
        lowercaseRegex,
        uppercaseRegex,
        numericRegex,
        nonalphanumeric,
        phoneNumbersFormat,
        charactersRegex
    } = useLogin()
    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            companyName: '',
            email: '',
            mobile: '',
            password: '',
            confirmPassword: '',
            acceptTerms: false,
            parkingNumber: '',
            isNewAccount:false,
            garage:[]
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required('Please enter First name'),
            lastName: Yup.string().required('Please enter Last name'),
            companyName: Yup.string('Please enter Company name'),
            email: Yup.string().required('Email address is required').email('Please enter a valid email'),
            mobile: Yup.string()
                .required('Please enter mobile number')
                .min(10, 'Please enter a valid mobile number')
                .max(13, 'Please enter a valid mobile number')
                .matches(phoneNumbersFormat, 'Please enter a number'),
            password: Yup.string()
                .min(9, 'Please enter a password')
                .matches(uppercaseRegex, 'At least 1 capital letter required')
                .matches(lowercaseRegex, 'At least 1 small letter required')
                .matches(numericRegex, 'At least 1 number required')
                .matches(nonalphanumeric, 'At least 1 special character required')
                .matches(charactersRegex, 'At least 1 special character (@, #, $, *) required')
                .required('Please enter a password'),
            confirmPassword: Yup.string().min(9, 'Please enter a password').required('Please re-enter password').oneOf([Yup.ref('password'), null], 'Passwords must a match'),
            acceptTerms: Yup.bool().oneOf([true], 'Please accept terms of use'),
            parkingNumber: Yup.string().required('Please enter access card number'),  
            garage:Yup.array().max(1,'Please select only one Garage').min(1,"Please select one Garage"),
            
        }), 
              
        onSubmit: (values, actions) => {
            const body = {
                first_name: values.firstName,
                last_name: values.lastName,
                company_name: values.companyName,
                mobile: values.mobile,
                email: values.email,
                password: values.password,
                access_card_number: values?.parkingNumber,
                garage_ids: values.garage,
                is_new_account: values.isNewAccount ? 1 : 0
            }
            handleRecaptchaVerify(body, actions)
        },
    })
    useEffect(() => {
        formik.setFieldValue('mobile', phoneNumber)
    }, [phoneNumber])

    return (
        <>

            <Section>
            <div className="auth-form-wrapper">
                <Text type="H1" text="Create Account"  />
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Input
                                    autoFocus={true}
                                    label="First name"
                                    type="text"
                                    name="firstName"
                                    placeholder=""
                                    value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.firstName && formik.errors.firstName ? (
                                        formik.errors.firstName
                                    ) : null}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Input
                                    label="Last name"
                                    type="text"
                                    name="lastName"
                                    placeholder=""
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.lastName && formik.errors.lastName ? (
                                        formik.errors.lastName
                                    ) : null}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-12">
                            <div className="formBox">
                                <Input
                                    label="Company / Organization"
                                    type="text"
                                    name="companyName"
                                    placeholder=""
                                    value={formik.values.companyName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.companyName && formik.errors.companyName ? (
                                        formik.errors.companyName
                                    ) : null}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <div className="form-field">
                                    <label className="form-label">Mobile number <span className="text-danger">*</span></label>
                                    <PhoneInput
                                        className={formik.touched.mobile && formik.errors.mobile ? 'error' : ''}
                                        defaultCountry={'US'}
                                        countries={['US']}
                                        placeholder="Enter mobile number"
                                        value={phoneNumber}
                                        onChange={setPhoneNumber}
                                        countryCallingCodeEditable={false}
                                        addInternationalOption={false}
                                        limitMaxLength="10"
                                        international
                                        
                                    />
                                </div>
                                <div className="formBox hiddenInput">
                                    <Input
                                        type="hidden"
                                        maxlength="10"
                                        name="mobile"
                                        placeholder=""
                                        value={formik.values.mobile}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        mandatory
                                        errormessage={formik.touched.mobile && formik.errors.mobile ? (
                                            formik.errors.mobile
                                        ) : null}
                                    />
                                </div>
                            </div>
                            </div>
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Input
                                    label="Email address"
                                    type="text"
                                    name="email"
                                    placeholder=""

                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.email && formik.errors.email ? (
                                        formik.errors.email
                                    ) : null}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Input
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    placeholder="********"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.password && formik.errors.password ? (
                                        formik.errors.password
                                    ) : null}
                                    icon={
                                        <span onClick={showPasswordClick}><EyeIcon visible={showPassword}/></span>
                                    }
                                    hint="Minimum 9 characters, 1 upper case, 1 lower case and 1 special character (@, #, $, *)"
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Input
                                    label="Confirm Password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    name="confirmPassword"
                                    placeholder="********"
                                    value={formik.values.confirmPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                        formik.errors.confirmPassword
                                    ) : null}
                                    icon={
                                        <span onClick={showConfirmPasswordClick}><EyeIcon visible={showConfirmPassword}/></span>
                                    }
                                    hint="Please re-enter password"
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="input-ticket-card">
                                <div className="input-ticket-heading">
                                    <div className="ith-left">
                                        <Text
                                            type="H4"
                                            className="ith-subtitle mb-0"
                                            text="Access Card Number"
                                        />
                                    </div>
                                    <div className="ith-right">
                                        <Text
                                            type="PARAGRAPH"
                                            className="mb-0"
                                            text="To link to an existing access card , please type the first sequence of numbers printed on your garage access card(up to 5 digits).  If unavailable, type “00000”."
                                        />
                                    </div>
                                </div>
                                <div className="formBox">
                                    <Input
                                        mb0
                                        type="text"
                                        name="parkingNumber"
                                        placeholder="Your access card number*"
                                        
                                        value={formik.values.parkingNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        mandatory
                                        errormessage={formik.touched.parkingNumber && formik.errors.parkingNumber ? (
                                            formik.errors.parkingNumber
                                        ) : null}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-12 col-md-3">
                            <Image
                                src={AccessCardDigitsImg} 
                                alt="Access Card Digits" 
                                className="border-img" 
                            />
                        </div>
                        <div className="col-12 col-md-6">
                                        <div className="formBox">
                                            <Checkbox
                                                name="isNewAccount"
                                                value={formik.values.isNewAccount}
                                                label={<>Is this a New Account?</>}
                                                id="isNewAccount"
                                                isChecked={formik.values.isNewAccount}
                                                onChange={formik.handleChange}
                                                errormessage={formik.touched.isNewAccount && formik.errors.isNewAccount ? (
                                                    formik.errors.isNewAccount
                                                ) : null}
                                                
                                            />

                                        </div>
                                    </div>
                        <div className="col-12 col-md-12">
                            <Text type="PARAGRAPH" className="form-label font-weight-500 mb-1" text="Please indicate which of the following garage you want to include with your Flex Daily Subscription." />
                            <Text type="PARAGRAPH" className="form-label" text="Note: Flex Daily parking rates may vary by location" />
                        </div>
                        {garagesList?.map((item, index) => {
                            return(
                                <div className="col-12 col-md-6" key={'garage'+index}>
                                    <Checkbox
                                        name="garage"
                                        value={item.id}
                                        label={item.location}
                                        id={item.id}
                                        onChange={formik.handleChange}
                                        errormessage={formik.touched.garage && formik.errors.garage ? (
                                            formik.errors.garage
                                        ) : null}
                                        mandatory
                                    />
                                    
                                </div>
                            )
                        })}
                        <div className="col-12 col-md-6">
                            <div className="formBox">
                                <Checkbox
                                    name="acceptTerms"
                                    value={formik.values.acceptTerms}
                                    label={<>I have read and agree to the <Link to="https://www.millenniumgarages.com/terms-of-use/" target="_blank">Terms of use</Link></>}
                                    id="acceptTerms"
                                    isChecked={formik.values.acceptTerms}
                                    onChange={formik.handleChange}
                                    errormessage={formik.touched.acceptTerms && formik.errors.acceptTerms ? (
                                        formik.errors.acceptTerms
                                    ) : null}
                                    mandatory
                                />

                            </div>
                        </div>
                    </div>
                    <Flex justifyContent="center" alignItemsCenter className="mb-48">
                        <Button
                            type="submit"
                            text="Sign up"
                            large
                            disabled={formik.isSubmitting}
                            isSubmitting={formik.isSubmitting}
                        />

                        <NavLink to='/login' className="px-5">Cancel</NavLink>
                    </Flex>
                    <Flex justifyContent="center" className="my-4">
                        <Text type="SPAN" text="Already have an account? " />
                        <NavLink to={'/login'} className="ml-2"><b><h4>Log In</h4></b></NavLink>
                    </Flex>
                </form>


            </div>
            </Section>
        </>
    )
}

export default RegisterView